import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Icon } from "@iconify/react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { Form, FormikProvider, useFormik } from "formik";
import EmptyImg from "../../../../img/empty.jpg";
import {
  getAllDesignations,
  getAllKras,
  tagKra,
  getAssignedKra,
  updateAssignedKra,
} from "../../../../redux/features/appraisalSlice";
import Addskill from "./AddSkill";
import Searchbar from "../../../../components/Search/Searchbar";
import {
  getAlldepartments,
  getDesignationUnderWings,
  getUserTypeUnderDesignation,
  getWingsUnderdpt,
} from "../../../../redux/features/generalSlice";

const TagSkill = ({ edit, editData, dispatchData }) => {
  const [open, setOpen] = useState(false);
  const [selectedKras, setSelectedKras] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [value, setValue] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedDept, setSelectedDept] = useState(null);
  const [selectedWing, setSelectedWing] = useState(null);
  const [selectedDesignation, setSelectedDesignation] = useState(null);

  const {
    alldepartments,
    wingsunderdpt,
    designationsunderwings,
    usertypeunderdesignation,
  } = useSelector((state) => state.general);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading, kralibraries } = useSelector((state) => state.appraisal);

  const ValidationSchema = Yup.object().shape({
    userTypeId: Yup.array()
      .of(Yup.number())
      .min(1, "Please select at least one designation")
      .required("Please select a designation"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userTypeId: [],
      masterDatas: [],
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      if (selectedKras.length === 0) {
        enqueueSnackbar("Please select a Skill", {
          variant: "error",
        });
        return;
      }
      const updatedMasterDatas = selectedKras.map((kra) => ({
        masterId: kra.appraisal_library_id,
        weightage: 100,
      }));
      const finalPayload = {
        ...values,
        masterDatas: updatedMasterDatas,
        type: "skills",
      };

      if (editData) {
        dispatch(updateAssignedKra(finalPayload)).then((res) => {
          if (res.payload.status === "success") {
            enqueueSnackbar(res.payload.message, { variant: "success" });
            setOpen(false);
            dispatch(getAssignedKra(dispatchData));
            setSelectedDept(null);
            setSelectedWing(null);
            setSelectedDesignation(null);
            setSelectedKras([]);
            setSelectedUsers([]);
            formik.resetForm();
          } else {
            enqueueSnackbar(res.payload.message, { variant: "error" });
          }
        });
      } else {
        dispatch(tagKra(finalPayload)).then((res) => {
          if (res.payload.status === "success") {
            enqueueSnackbar(res.payload.message, { variant: "success" });
            setOpen(false);
            dispatch(getAssignedKra(dispatchData));
            setSelectedDept(null);
            setSelectedWing(null);
            setSelectedDesignation(null);
            setSelectedKras([]);
            setSelectedUsers([]);
            formik.resetForm();
          } else {
            enqueueSnackbar(res.payload.message, { variant: "error" });
          }
        });
      }
    },
  });

  const handleKraToggle = (kra) => {
    const exists = selectedKras.find(
      (item) => item.appraisal_library_id === kra.appraisal_library_id
    );
    if (exists) {
      setSelectedKras((prev) =>
        prev.filter(
          (item) => item.appraisal_library_id !== kra.appraisal_library_id
        )
      );
    } else {
      setSelectedKras((prev) => [...prev, kra]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedKras([]);
    } else {
      setSelectedKras(kralibraries);
    }
    setSelectAll(!selectAll);
  };

  const data = {
    search: value || "",
    type: "skills",
  };

  useEffect(() => {
    if (open) {
      dispatch(getAllKras(data));
      dispatch(getAlldepartments());
    }
  }, [open, value]);

  useEffect(() => {
    if (selectedDept) {
      dispatch(getWingsUnderdpt(selectedDept.dept_id));
      setSelectedWing(null);
      setSelectedDesignation(null);
      setSelectedUsers([]);
    }
  }, [selectedDept]);

  useEffect(() => {
    if (selectedWing) {
      dispatch(getDesignationUnderWings(selectedWing.wing_id));
      setSelectedDesignation(null);
      setSelectedUsers([]);
    }
  }, [selectedWing]);

  useEffect(() => {
    if (selectedDesignation) {
      dispatch(getUserTypeUnderDesignation(selectedDesignation.designationID));
      setSelectedUsers([]);
    }
  }, [selectedDesignation]);

  useEffect(() => {
    if (edit && open && editData) {
      const user = {
        userType: editData.usertypeDetails.userType,
        usertypeID: editData.usertypeDetails.userTypeId,
      };
      setSelectedUsers([user]);
      formik.setFieldValue("userTypeId", [user.usertypeID]);

      const selected = editData.libraryDetails.map((kra) => ({
        appraisal_library_id: kra.appraisal_library_id,
        appraisal_library_name: kra.libraryName,
      }));
      setSelectedKras(selected);
    }
  }, [edit, open, editData]);

  const handleusertype = (e, selectedOptions) => {
    const uniqueUsers = Array.from(
      new Map(selectedOptions.map((user) => [user.userType, user])).values()
    );

    setSelectedUsers(uniqueUsers);
    const typeIDs = uniqueUsers.map((user) => user.usertypeID);
    formik.setFieldValue("userTypeId", typeIDs);
  };

  return (
    <GlobalDialog
      title={"Tag Skill"}
      open={open}
      setOpen={setOpen}
      fullWidth
      fullScreen
      maxWidth={"lg"}
      closeButton={true}
      popupButton={
        edit ? (
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => setOpen(true)}
          >
            <Icon icon="mdi:pencil" width={18} height={18} />
          </Button>
        ) : (
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => setOpen(true)}
          >
            Tag Skill
          </Button>
        )
      }
      content={
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", sm: "center" },
                flexDirection: { xs: "column", sm: "row" },
                boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
                borderRadius: "8px",
                padding: 3,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  padding: 2,
                  width: {
                    xs: "100%",
                    sm: "40%",
                  },
                }}
              >
                <Autocomplete
                  size="small"
                  options={alldepartments}
                  getOptionLabel={(option) => option.dept_name || ""}
                  value={selectedDept}
                  onChange={(e, newValue) => setSelectedDept(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="Department" fullWidth />
                  )}
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "100%",
                    },
                    mb: 1,
                  }}
                />

                <Autocomplete
                  size="small"
                  options={wingsunderdpt}
                  getOptionLabel={(option) => option.wing_name || ""}
                  value={selectedWing}
                  onChange={(e, newValue) => setSelectedWing(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="Wing" fullWidth />
                  )}
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "100%",
                    },
                    mb: 1,
                  }}
                  disabled={!selectedDept}
                />

                <Autocomplete
                  size="small"
                  options={designationsunderwings}
                  getOptionLabel={(option) => option.designationName || ""}
                  value={selectedDesignation}
                  onChange={(e, newValue) => setSelectedDesignation(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="Designation" fullWidth />
                  )}
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "100%",
                    },
                    mb: 1,
                  }}
                  disabled={!selectedWing}
                />

                <Autocomplete
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "100%",
                    },
                    mb: 1,
                  }}
                  size="small"
                  multiple
                  name="userTypeId"
                  options={usertypeunderdesignation}
                  disabled={!selectedDesignation}
                  value={selectedUsers}
                  onChange={handleusertype}
                  getOptionLabel={(option) => option.userType || ""}
                  renderInput={(params) => (
                    <TextField
                      disabled
                      fullWidth
                      autoComplete="off"
                      {...params}
                      label="UserType"
                      error={
                        formik.touched.userTypeId &&
                        Boolean(formik.errors.userTypeId)
                      }
                      helperText={
                        formik.touched.userTypeId && formik.errors.userTypeId
                      }
                    />
                  )}
                />
              </Box>
              <Stack direction={"column"} spacing={1}>
                <Chip
                  label="Skill weightage is 100"
                  variant="contained"
                  color="secondary"
                />
                {selectedKras.length > 0 && (
                  <>
                    <Chip
                      label={`No. of Skills Selected : ${selectedKras?.length}`}
                      variant="contained"
                      color="secondary"
                    />
                  </>
                )}
              </Stack>
            </Box>

            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "#d2d2d2ff",
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                    justifyContent: "space-between",
                    padding: 1,
                    borderRadius: "8px",
                    mb: 1,
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <Checkbox checked={selectAll} onChange={handleSelectAll} />
                    <Typography variant="body2">Choose Skill</Typography>
                  </Box>
                  <Box
                    sx={{
                      mb: {
                        xs: 1,
                        sm: 0,
                      },
                    }}
                  >
                    <Searchbar
                      value={value}
                      setValue={setValue}
                      width={"200px"}
                      label={"Search Item"}
                    />
                  </Box>
                  <Box>
                    <Addskill dispatchData={data} />
                  </Box>
                </Box>

                <Stack direction="column" spacing={1}>
                  {kralibraries.map((kra) => (
                    <Box
                      key={kra.appraisal_library_id}
                      display="flex"
                      alignItems="center"
                      sx={{
                        borderRadius: "6px",
                        px: 2,
                        py: 1,
                        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
                      }}
                    >
                      <Checkbox
                        checked={selectedKras.some(
                          (item) =>
                            item.appraisal_library_id ===
                            kra.appraisal_library_id
                        )}
                        onChange={() => handleKraToggle(kra)}
                      />
                      <Typography variant="body2">
                        {kra.appraisal_library_name}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "#d2d2d2ff",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 1,
                    borderRadius: "8px",
                    mb: 1,
                  }}
                >
                  <Box>
                    <Typography variant="body2">Skill</Typography>
                  </Box>
                  <Box>
                    <Searchbar
                      value={value}
                      setValue={setValue}
                      width={"200px"}
                      label={"Search Item"}
                    />
                  </Box>
                </Box>

                {selectedKras.length < 1 ? (
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                  >
                    <img
                      src={EmptyImg}
                      alt=""
                      style={{
                        width: "40%",
                        height: "auto",
                        objectFit: "contain",
                      }}
                    />
                    <Typography variant="caption">
                      No records found yet
                    </Typography>
                  </Box>
                ) : (
                  <Stack spacing={2}>
                    {selectedKras.map((kra) => (
                      <Box
                        key={kra.appraisal_library_id}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                          borderRadius: "6px",
                          px: 2,
                          py: 1,
                          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
                        }}
                      >
                        <Typography sx={{ flex: 1 }} variant="body2">
                          {kra.appraisal_library_name}
                        </Typography>
                        <Button
                          color="error"
                          variant="outlined"
                          size="small"
                          onClick={() => handleKraToggle(kra)}
                        >
                          <Icon
                            icon="basil:cross-solid"
                            width={20}
                            height={20}
                          />
                        </Button>
                      </Box>
                    ))}
                  </Stack>
                )}
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}>
              <Stack direction={"row"} spacing={1}>
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => setOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  disabled={loading}
                  size="small"
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  {loading ? "Please wait..." : "Save"}
                </Button>
              </Stack>
            </Box>
          </Form>
        </FormikProvider>
      }
    />
  );
};

export default TagSkill;
